export default __webpack_public_path__ + "static/media/Dori.a72ef325.png";